<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    needNotify: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    const { icon, title, needNotify } = context.props
    const vnodes = []
    if (icon) {
      if (icon.includes('el-icon')) {
        if (needNotify) {
          vnodes.push(<i class={[icon, 'sub-el-icon']} style="color: red;" />)
        } else {
          vnodes.push(<i class={[icon, 'sub-el-icon']} />)
        }
      } else {
        if (needNotify) {
          vnodes.push(<svg-icon icon-class={icon} style="color: red;" />)
        } else {
          vnodes.push(<svg-icon icon-class={icon} />)
        }
      }
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>
